export default "__VITE_ASSET__49431204__"